export default "__VITE_ASSET__NFjoJ3Sc__"